import React from "react";

const Technics: React.FC = () => {
  return (
    <div>
      <h1>Teknikler</h1>
      <p>Teknik yönetimi sayfası burada geliştirilecek.</p>
    </div>
  );
};

export default Technics;
